// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1JWYh","name":"Header_name__3w3rJ","birthday":"Header_birthday__3JEkp","skeleton":"Header_skeleton__VdC3i"};